import React from 'react';
import { Card, Typography, Button, Space, Tag } from 'antd';
import { UserOutlined, CommentOutlined, TagOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const BlogPost = ({
  id,
  title,
  author,
  category,
  comments,
  images,
  textContent,
  readMoreLink
}) => {
  const firstImage = images.length > 0 ? images[0] : null;

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  return (
    <Card
      hoverable
      style={{ marginBottom: '20px' }}
      bodyStyle={{ padding: '20px' }}
    >
      <Title level={3}>
        <a href={`/blog/${id}`} style={{ color: '#050505' }}>{title}</a>
      </Title>
      <Space size="middle" style={{ marginBottom: '15px' }}>
      <Text style={{ color: '#0586e8' }}><UserOutlined /> {author}</Text>
      <Tag color="volcano"><TagOutlined /> {category}</Tag>
        <Text><CommentOutlined /> {comments} Comments</Text>
      </Space>
      
      {firstImage && (
        <div style={{ marginBottom: '15px' }}>
          <img
            alt="Blog Image"
            src={firstImage}
            style={{
              // width: '100%',   // Makes the image take full width of the container
              height: '300px',  // Fixes the height
              objectFit: 'contain',  // Ensures the image is scaled down without cropping
              backgroundColor: '#f0f0f0'  // Adds a background color to fill empty spaces
            }}
          />
        </div>
      )}
      
      <div>
        <Paragraph style={{ 
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}>
          {truncateText(textContent, 1000)} {/* Limits text content to 1000 characters */}
        </Paragraph>
      </div>
      <Button
  type="default"  // Sets the button type to default (outline style)
  ghost          // Makes the button outlined
  style={{
    borderColor: '#ff7a45', // Custom border color
    color: '#ff7a45',       // Custom text color
  }}
  href={readMoreLink}
>
  Read More
</Button>
    </Card>
  );
};

export default BlogPost;
